export class DeleteCloudEnvironmentRequest {
    environmentId?: string;
}